import { SalesforceConfigurationType } from './ai';
import { RecordTypeProperties } from './documentation';

// Salesforce configurations
export const PATH_ASSISTANT = 'PathAssistant';
export const VALIDATION_RULE = 'ValidationRule';
export const APPROVAL_PROCESS = 'ApprovalProcess';
export const WORKFLOW_RULE = 'WorkflowRule';
export const FLOW = 'Flow';
export const APEX_CLASS = 'ApexClass';
export const PATH = 'Path';
export const FIELD = 'Field';
export const PROCESS_BUILDER_FLOW = 'ProcessBuilderFlow';
export const LAYOUT = 'Layout';
export const APEX_TRIGGER = 'ApexTrigger';
export const EMAIL_TEMPLATE = 'EmailTemplate';
export const REPORT = 'Report';
export const RECORD_TYPE = 'RecordType';

export enum ConfigurationType {
  validationRules = 'validationRules',
  approvalProcesses = 'approvalProcesses',
  workflowRules = 'workflowRules',
  flows = 'flows',
  processBuilderFlows = 'processBuilderFlows',
  apexTriggers = 'apexTriggers',
  apexClasses = 'apexClasses',
  fields = 'fields',
  reports = 'reports',
  layouts = 'layouts',
  emailTemplates = 'emailTemplates',
  objects = 'objects',
  sweepAutomation = 'automations',
  sweepAlert = 'alerts',
  sweepDedupe = 'dedup',
  sweepMatching = 'matching',
  sweepAssignment = 'assignments',
  sweepScheduledAssignment = 'scheduledAssignments',
  rollups = 'rollups',
  cpqData = 'cpqData',
  recordTypes = 'recordTypes',
  paths = 'paths',
  relatedObjects = 'relatedObjects',
  others = 'others',
}

export enum OpenAIConfigurationKeys {
  VALIDATION_RULES = 'validationRules',
  APPROVAL_PROCESSES = 'approvalProcesses',
  WORKFLOW_RULES = 'workflowRules',
  PROCESS_BUILDER_FLOWS = 'processBuilderFlows',
  FLOWS = 'flows',
  LAYOUTS = 'layouts',
  APEX_TRIGGERS = 'apexTriggers',
  APEX_CLASSES = 'apexClasses',
  CPQ_DATA = 'cpqData',
}

export const configurationKeyToType: {
  [key in Exclude<
    OpenAIConfigurationKeys,
    OpenAIConfigurationKeys.CPQ_DATA
  >]: SalesforceConfigurationType;
} = {
  [OpenAIConfigurationKeys.VALIDATION_RULES]: VALIDATION_RULE,
  [OpenAIConfigurationKeys.APPROVAL_PROCESSES]: APPROVAL_PROCESS,
  [OpenAIConfigurationKeys.WORKFLOW_RULES]: WORKFLOW_RULE,
  [OpenAIConfigurationKeys.PROCESS_BUILDER_FLOWS]: FLOW,
  [OpenAIConfigurationKeys.FLOWS]: FLOW,
  [OpenAIConfigurationKeys.LAYOUTS]: LAYOUT,
  [OpenAIConfigurationKeys.APEX_TRIGGERS]: APEX_TRIGGER,
  [OpenAIConfigurationKeys.APEX_CLASSES]: APEX_CLASS,
} as const;

export type RecordTypeParserProperties = RecordTypeProperties & {
  leadingFields: LeadingFieldData[]; // TODO SWEEP-3940 - remove when leading fields are removed from parser
  attributions?: Attributions;
};

type Attributions = {
  [ConfigurationType.layouts]?: string[];
  [ConfigurationType.validationRules]?: string[];
  [ConfigurationType.flows]?: string[];
  [ConfigurationType.processBuilderFlows]?: string[];
  [ConfigurationType.workflowRules]?: string[];
  [ConfigurationType.approvalProcesses]?: string[];
};

// TODO SWEEP-3940 - remove when leading fields are removed from parser
interface LeadingFieldData {
  name: string;
  label: string;
  values: LeadingFieldValue[];
  hasPath: boolean;
  isLeadingCandidate?: boolean;
}

// TODO SWEEP-3940 - remove when leading fields are removed from parser
type LeadingFieldValue = {
  name: string;
  label: string;
  metadata?: any;
  [ConfigurationType.validationRules]?: string[];
  [ConfigurationType.flows]?: string[];
  [ConfigurationType.processBuilderFlows]?: string[];
  [ConfigurationType.workflowRules]?: string[];
  [ConfigurationType.approvalProcesses]?: string[];
};
